import {gql, useLazyQuery} from "@apollo/client";
import {useLogger} from "./useLogger";
import {getBrowser} from "../common/common";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";

const QUERY = gql`
query getBookingInformation($locale: String!){
   bookingInformationCollection(limit: 1, locale: $locale) {
    items {
      resultFile {
        url
      }
      pointsFreeResultFile {
        url
      }
    }
  }
}`;

export const useBookingInformation = () => {
    const {logger} = useLogger();
    const {localeUppercase} = useContext(LocaleContext)[0];

    const [getBookingInformation, { loading, data, error }] = useLazyQuery(QUERY, {
        variables: { locale: localeUppercase },
        fetchPolicy: getBrowser() === "Safari" ? "network-only" : "cache-first",
        errorPolicy: "all"
    });

    const bookingInformationUrl = data?.bookingInformationCollection?.items?.[0]?.resultFile?.url;
    const bookingInformationPointsFreeWeeksUrl = data?.bookingInformationCollection?.items?.[0]?.pointsFreeResultFile?.url;

    if (error?.message) {
        logger(error?.message, "error", "useBookingInformation", error?.stack);
    }

    return {
        getBookingInformation,
        bookingInformationUrl,
        bookingInformationPointsFreeWeeksUrl,
        bookingInformationLoading: loading
    };
};
